<template>
	<div class="flex items-center justify-center px-6 py-6">
		<UndrawEmpty v-if="!isText" class="h-auto w-full max-w-sm text-company opacity-75" />
		<span v-else class="text-neutral-700 pointer-events-none select-none text-4xl font-black opacity-30">
			{{ $t("empty") }}
		</span>
	</div>
</template>

<script lang="ts" setup>
import UndrawEmpty from "~/assets/svg/undraw_empty_re_opql.svg"

defineProps<{
	isText?: boolean
}>()
</script>
